import { Component, Input, AfterContentInit, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-loading-spinner',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule],
  templateUrl: './loading-spinner.component.html',
})
export class LoadingSpinnerComponent implements AfterContentInit {
  @Input() loading: boolean = false;
  @Input() diameter: number = 20;
  
  hasContent = false;

  constructor(private elementRef: ElementRef) {}

  ngAfterContentInit() {
    const contentElement = this.elementRef.nativeElement.querySelector('span');
    this.hasContent = contentElement && contentElement.childNodes.length > 0;
  }
}
